function deline(strings) {
  var raw = void 0;
  if (typeof strings === 'string') {
    raw = [strings];
  } else {
    raw = strings.raw;
  }
  var resultArr = [];
  for (var i = 0; i < raw.length; i++) {
    resultArr.push(raw[i].replace(/\\\n[ \t]*/g, '').replace(/\\`/g, '`'));
    if (i < (arguments.length <= 1 ? 0 : arguments.length - 1)) {
      resultArr.push(arguments.length <= i + 1 ? undefined : arguments[i + 1]);
    }
  }
  var result = resultArr.join('').trim();

  var lines = result.split('\n');
  var ret = lines.reduce(function (accumulator, line, idx) {
    var lineTrimmed = line.trim();
    if (accumulator.length > 0 && lineTrimmed === '' && accumulator[accumulator.length] === '\n') {
      return accumulator;
    }
    if (lineTrimmed === '') {
      accumulator.push(accumulator.pop().slice(0, -1));
      accumulator.push('\n');
    } else {
      accumulator.push('' + String(lineTrimmed) + (idx !== lines.length - 1 ? ' ' : ''));
    }
    return accumulator;
  }, []);
  return ret.join('').trim().replace(/\\n/g, '\n');
}

module.exports = deline;

//# sourceMappingURL=deline.js.map